// src/components/ErrorBoundary.jsx
import React from 'react';
import { useRouteError } from 'react-router-dom';

const ErrorBoundary = () => {
    const error = useRouteError();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-md max-w-lg w-full">
                <h1 className="text-2xl font-bold text-red-600 mb-4">Oops! Something went wrong</h1>
                <div className="bg-red-50 border border-red-200 rounded p-4 mb-4">
                    <p className="text-red-800">{error?.message || 'An unexpected error occurred'}</p>
                    {error?.stack && (
                        <pre className="text-xs mt-2 overflow-auto max-h-40">{error.stack}</pre>
                    )}
                </div>
                <button
                    onClick={() => window.location.reload()}
                    className="bg-primary text-white px-4 py-2 rounded hover:bg-primary/90"
                >
                    Reload Page
                </button>
            </div>
        </div>
    );
};

export default ErrorBoundary;